import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { ValidateCSVAndBulkAssignSpocsToRespondentsRPC } from "./validateCsvAndBulkAssignSpocsToRespondentsRPC";

export class ValidateCSVAndBulkAssignSpocsToRespondentsRPCClientImpl extends ValidateCSVAndBulkAssignSpocsToRespondentsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: ValidateCSVAndBulkAssignSpocsToRespondentsRPC.Request): Promise<LeoRPCResult<ValidateCSVAndBulkAssignSpocsToRespondentsRPC.Response, ValidateCSVAndBulkAssignSpocsToRespondentsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "spoc-management/ValidateCSVAndBulkAssignSpocsToRespondents",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      ValidateCSVAndBulkAssignSpocsToRespondentsRPC.ResponseDTO,
      ValidateCSVAndBulkAssignSpocsToRespondentsRPC.Errors.ErrorsDTO,
      ValidateCSVAndBulkAssignSpocsToRespondentsRPC.Response,
      ValidateCSVAndBulkAssignSpocsToRespondentsRPC.Errors.Errors
    >(
      response,
      "spoc-management/ValidateCSVAndBulkAssignSpocsToRespondents",
      ValidateCSVAndBulkAssignSpocsToRespondentsRPC.Response.fromDTO,
      ValidateCSVAndBulkAssignSpocsToRespondentsRPC.Errors.fromDTO
    );
  }
}
